import React, { Component } from 'react'
import axios from 'axios'
import Layout from '../layout/Layout'
import { api } from '../utils/Api'
import Spinner from '../layout/Spinner'
import Modal from 'react-bootstrap/Modal'
import { Link } from 'react-router-dom'
import SendEticketJob from './SendEticketJob'

export default class EticketJob extends Component {
    constructor(props) {
        super(props)

        this.state = {
            showModalEmail: false,
            showModalSms: false,
            pdf: '',
            loading: true
        }
    }

    /**
     * Get PDF Etickets
     */
    getPDFEtickets  = async () => {
        const url = api + `/eticketsjobpdf/${this.props.match.params.id}`
        const token = localStorage.getItem('token')
        axios.defaults.headers.common = { 'Authorization': `Bearer ${token}` }

        try {
            const { data } = await axios.post(url)
            this.setState({
                pdf: data,
                loading: false
            })
        } catch (err) {
            console.error(err)
            return null
        }
    }

    /**
     * Open and close email modal
     * @param {Event} e event of the modal
     */
    toggleModalEmail = (e) => {
        this.setState({
            showModalEmail: !this.state.showModalEmail
        })
    }

    /**
     * Open and close sms modal
     * @param {Event} e event of the modal
     */
    toggleModalSms = (e) => {
        this.setState({
            showModalSms: !this.state.showModalSms
        })
    }

    sendEmails = async () => {
        const url = api + `/eticketsjobsend/${this.props.match.params.id}?type=${'email'}`
        const token = localStorage.getItem('token')
        axios.defaults.headers.common = { 'Authorization': `Bearer ${token}` }

        try {
            await axios.post(url)
        } catch (err) {
            console.error(err)
            return null
        }
    }

    sendSms = async () => {
        const url = api + `/eticketsjobsend/${this.props.match.params.id}?type=${'sms'}`
        const token = localStorage.getItem('token')
        axios.defaults.headers.common = { 'Authorization': `Bearer ${token}` }

        try {
            await axios.post(url)
        } catch (err) {
            console.error(err)
            return null
        }
    }

    componentDidMount() {
        this.getPDFEtickets()
    }

    render() {

        return (
            <Layout
                title='Job Etickets PDF'
                description='Job Etickets'
                className="container col-md-12"
            >
                <div>
                    <Link onClick={this.toggleModalEmail}
                    to='#'
                    className="btn btn-primary"
                    >
                        Send etickets by email
                    </Link>                
                    <Link onClick={this.toggleModalSms}
                        to='#'
                        className="btn btn-success"
                        style={{marginLeft:20}}
                    >
                        Send etickets by SMS
                    </Link>  
                    <Link onClick={this.sendEmails}
                        to='#'
                        className="btn btn-primary"
                        style={{marginLeft:20}}
                    >
                        Send etickets to all emails
                    </Link> 
                    <Link onClick={this.sendSms}
                        to='#'
                        className="btn btn-secondary"
                        style={{marginLeft:20}}
                    >
                        Send etickets to all SMS
                    </Link>  
                </div>
                             
                <Modal show={this.state.showModalEmail} animation={false} onHide={this.toggleModalEmail}>
                    <Modal.Header closeButton>
                        <Modal.Title>Send Etickets to:</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <SendEticketJob 
                            jobId={this.props.match.params.id} 
                            pcallback={this.toggleModalEmail}
                            isEmail={true}
                        />
                    </Modal.Body>
                </Modal>  
                <Modal show={this.state.showModalSms} animation={false} onHide={this.toggleModalSms}>
                    <Modal.Header closeButton>
                        <Modal.Title>Send Etickets to:</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <SendEticketJob 
                            jobId={this.props.match.params.id} 
                            pcallback={this.toggleModalSms}
                            isEmail={false}
                        />
                    </Modal.Body>
                </Modal>  
                {
                    this.state.loading ? <Spinner/> : <iframe src={this.state.pdf} width='95%' style={{height: '90vh'}} />
                }
                
            </Layout>
        )
    }
}